import React from "react";
import { Modal, ModalContentWrapper, Button, Spinner } from "components";

interface ConfirmDeleteModalProps<T> {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  itemToDelete?: T;
  itemName?: string;
  isLoading?: boolean;
  confirmButtonText?: string;
  cancelButtonText?: string;
}

export const ConfirmDeleteModal = <T,>({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  itemToDelete,
  itemName,
  isLoading = false,
  confirmButtonText = "Delete",
  cancelButtonText = "Cancel",
}: ConfirmDeleteModalProps<T>) => {
  
  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Modal
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      closeWhenClickOutside={!isLoading}
    >
      <ModalContentWrapper>
        <div className="space-y-4">
          <div className="space-y-2 max-w-md" >
            <p className="text-base break-words">{description}</p>
            {itemName && (
              <p className="text-base font-bold text-gray-900">{itemName}</p>
            )}
          </div>

          <div className="flex justify-end gap-3 pt-4">
            <Button
              onClick={onClose}
              variant="secondary"
              disabled={isLoading}
            >
              {cancelButtonText}
            </Button>
            <Button
              onClick={handleConfirm}
              variant="destructive"
              disabled={isLoading}
            >
              {isLoading && <Spinner />}
              {isLoading ? "Deleting..." : confirmButtonText}
            </Button>
          </div>
        </div>
      </ModalContentWrapper>
    </Modal>
  );
};
